import api from "@/aygulyazilim/libs/axios"
import { useHelpersStore } from "@/aygulyazilim/store/useHelpers"
import { getI18n } from "@/plugins/i18n"
import { defineStore } from "pinia"
import { reactive } from "vue"

export const useAnaSayfaStore = defineStore("anaSayfa", {
  state: () => ({
    isLoading: false,
    queryCard: [],
    usersHedefRandevu: null,
    usersHedef: [],
    hedefKampanya: [],
    hedefKampanyaSonuc: [],
    takimKampanyaSonuc: [],
    takimKampanyalarim: [],
    takimElemanlari: [],
    dogumgunleri: [],
    arsiv: [],
    katilanonaylist: [],
    veriKontrol: {
      onthejobtraining: 0,
      onetoone: 0,
      musteriyetki: 0,
    },
  }),
  getters: {
    getItemByName: state => {
      return name => {
        const item = state.queryCard.find(item => item.name === name)
        
        return item ? item.deger : 0
      }
    },
  },
  actions: {
    async fetchData() {
      const helpersStore = useHelpersStore()

      this.isLoading = true
      try {
        const res = await api.get("anasayfa")

        this.queryCard = res?.data?.queryCard || []
      } catch (error) {
        helpersStore.toast(
          "error",
          getI18n().global.t("anasayfa.Veri çekilirken bir hata oluştu"),
        )
      } finally {
        this.isLoading = false
      }
    },
    async getPreference(key) {
      try {
        const res = await api.get(`users/preference/${key}`)
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async setPreference(key, value) {
      try {
        await api.post("users/preference", { key, value })
      } catch (error) {
        console.error("Preference save error:", error)
      }
    },
    async gonderKonum(data) {
      try {
        await api.post("anasayfa/konum", data)
      } catch (error) {
        console.error("Konum gonderim hatası:", error)
      }
    },
    async fetchUsersHedefRandevu(uuid) {
      try {
        const res = await api.get(`anasayfa/users_hedef_randevu/${uuid}`)

        this.usersHedefRandevu = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchUsersHedef(uuid) {
      try {
        const res = await api.get(`anasayfa/users_hedef/${uuid}`)

        this.usersHedef = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchHedefKampanya(uuid) {
      try {
        const res = await api.get(`anasayfa/hedef_kampanya/${uuid}`)

        this.hedefKampanya = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchHedefKampanyaSonuc(params) {
      try {
        const res = await api.post(`anasayfa/hedef_kampanyaSonuc`, params)

        this.hedefKampanyaSonuc = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchTakimKampanyaSonuc(params) {
      try {
        const res = await api.post(`anasayfa/takim_kampanyaSonuc`, params)

        this.takimKampanyaSonuc = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchTakimKampanyalarim() {
      try {
        const res = await api.get(`anasayfa/takimKampanyalarim`)

        this.takimKampanyalarim = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchTakimElemanlari() {
      try {
        const res = await api.get(`anasayfa/takimElemanlari`)

        this.takimElemanlari = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchDogumgunleri() {
      try {
        const res = await api.get(`anasayfa/dogumgunleri`)

        this.dogumgunleri = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchArsiv() {
      try {
        const res = await api.get(`anasayfa/arsiv`)

        this.arsiv = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchKatilanonaylist() {
      try {
        const res = await api.get(`anasayfa/katilanonaylist`)

        this.katilanonaylist = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async katilanonay(params) {
      try {
        const res = await api.post(`anasayfa/katilanonay`, params)
        
        return res.data
      } catch (error) {
        return null
      }
    },
    async fetchVeriKontrol() {
      try {
        const res = await api.get(`anasayfa/veriKontrol`)

        this.veriKontrol = res.data
        
        return res.data
      } catch (error) {
        return null
      }
    },
  },
})
